// extracted by mini-css-extract-plugin
export var root = "yNLt";
export var rootButton = "_1Sz9";
export var rootHeading = "-Dh+";
export var rootText = "e8i0";